import React, { FC } from 'react';
import { LandscapeProjectNotSavedInfoTemplate } from '../../templates';

interface LandscapeProjectNotSavedInfoPageProps {}

const LandscapeProjectNotSavedInfoPage: FC<
  LandscapeProjectNotSavedInfoPageProps
> = () => {
  return (
    <LandscapeProjectNotSavedInfoTemplate
      content={'Feature only available after the project is created'}
    />
  );
};

export default LandscapeProjectNotSavedInfoPage;
